<template>
    <div class="t_c_todo_wrap">
        <div class="form_input mb_15" :class="[{'has_error': errorFor('content')}]">
            <input type="text" class="form_global" ref="todoInput" placeholder="Add To Do" v-model="form.content" @keyup.enter="saveTodo">
        </div>
        <div class="inner" v-for="(todo, index) in todos" :key="'todo_'+index">
            <div class="inner_wrap">
                <div class="contact_name">
                    <!-- <div class="checked_todo">
                        <div class="form_checkbox p_0">
                            <input type="checkbox" id="c1">
                            <label for="c1" class="pl_10"></label>
                        </div>
                    </div> -->
                    <div class="text">
                        <p>{{ todo.content }}</p>
                        <p v-if="!todo.ticket_id">
                            <router-link v-if="todo.contact" :to="`/contact/${todo.contact_id}/show`">{{ todo.contact.name }}</router-link>
                            <router-link v-else :to="`/company/${todo.company_id}/show`">{{ todo.company.company_name }}</router-link>
                        </p>
                    </div>
                </div>
                <div class="on_hover">
                    <ul class="d_flex_end ">
                        <li class=" d_flex_center" @click.prevent="editTodo(todo)"><img src="@/assets/media/images/edit.png" alt=""></li>
                        <li class=" d_flex_center" @click.prevent="deleteTodo(todo.id)"><img src="@/assets/media/images/trash.png" alt=""></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'todos',
    data(){
        return {
            form: {
                content: ''
            },
            editable: false,
            editableTodoId: '',
        }
    }, 
    props:{
        todos:{
            required:false, 
            type: Array
        },
        type: {
            required: true,
            type:String
        },
        fromId: {
            required: true,
            type: String
        },

    },
    methods: {
        saveTodo(){
            this.allErrors = null;
            this.lyLoading = true;

            this.form.type = this.type
            this.form.from_id = this.fromId

            if(this.editable){
                this.axios.patch('/todos/'+this.editableTodoId, this.form)
                .then((response) => {
                    this.showSuccessMsg("Todo updated successfully!");
                    this.form.content = ''
                    this.editable = false
                    this.editableTodoId = ''
                    this.$emit('todo-updated', response.data.data); 
                })
                .catch((err) => {
                    this.allErrors = err.response.data.errors
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            }else{
                this.axios.post('/todos', this.form)
                .then((response) => {
                    this.showSuccessMsg("Todo created successfully!");
                    this.form.content = ''
                    this.$emit('todo-added', response.data.data); 
                })
                .catch((err) => {
                    this.allErrors = err.response.data.errors
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            }

            
        },
        editTodo(todo){
            this.allErrors = null;
            this.editable = true
            this.editableTodoId = todo.id
            this.$refs.todoInput.focus()
            this.form.content = todo.content
        },
        deleteTodo(todoId) {
                this.$swal({
                    title: 'Are you sure want to delete?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.axios.delete('/todos/'+todoId).then(() => {
                            this.$emit('todo-deleted', todoId);
                            this.$swal.fire(
                                'Deleted',
                                'Data has been deleted!',
                                'success'
                            )
                        });
                    }
                });
            },
    }
}
</script>